import mutations from './mutations'
import state from './state'

export default {
  mutations,
  state,
  namespaced: true,
}

